import Vue from 'vue';
import AppVisibleProductsCount from '@/plugins/graphql/queries/v2/ecommerce/app-visible-products-count.gql';
export default Vue.extend({
    apollo: {
        appVisibleProductsCount: {
            query: AppVisibleProductsCount,
            fetchPolicy: 'cache-and-network',
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                return data.appVisibleProductsCount;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    methods: {
        refetchProductsCount() {
            this.$apollo.queries.appVisibleProductsCount.refetch();
        }
    },
    data() {
        return {
            appVisibleProductsCount: 0,
        };
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                appVisibleProductsCount: this.appVisibleProductsCount,
            });
        }
    },
});
